module.exports = __webpack_public_path__ + "static/img/bg2.d84614a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/bg2.png
// module id = P73k
// module chunks = 0